import TabBarLayout from './tabBarLayout';
import SidebarLayout from './sidebarLayout';

export default {
	TabBarLayout,
	SidebarLayout
};
